import React from 'react';
import Calculadora from '../../../components/ui/Admin/CalculadoraComponents/Calculadora';

const CalculadoraOperacionesUI = () => {
  return (
    <div className="pb-4">
      <Calculadora allowEditing={false} apiBasePath="/api/operaciones" allowGroupLoan={false} />
    </div>
  );
};

export default CalculadoraOperacionesUI;
